import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { loginAdmin } from "../services/AdminService";
import { useDispatch } from "react-redux";
import { setAuth } from "../Redux/authSlice";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function LoginAdmin() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    // Si déjà connecté en admin → rediriger vers le panel
    useEffect(() => {
        const token = localStorage.getItem("token_admin") || sessionStorage.getItem("token_admin");
        const role = localStorage.getItem("role");
        if (token && role === "admin") {
            navigate("/admin");
        }
    }, [navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!email || !password) {
            toast.error("Veuillez remplir tous les champs !");
            return;
        }

        setLoading(true);
        try {
            const response = await loginAdmin(email, password);

            // Sécurité supplémentaire : vérifier le rôle renvoyé
            if (response.user?.role !== "admin") {
                toast.error("Ce compte n'est pas un compte administrateur.");
                setLoading(false);
                return;
            }

            toast.success("Connexion admin réussie !");

            // Stockage
            localStorage.setItem("token_admin", response.token);
            localStorage.setItem("role", "admin");
            dispatch(setAuth({ token: response.token, user: response.user }));

            navigate("/admin");
        } catch (err) {
            console.error(err);
            toast.error(err.message || "Identifiants administrateur incorrects.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Helmet>
                <title>Connexion Admin — Thrundrz</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <Navbar />

            <main
                className="bg-color4 lg:h-screen text-color2 lg:py-20 py-16 pt-24 px-4 lg:pt-36"
                id="login-admin"
            >
                <div className="w-full lg:px-20 px-3 mx-auto flex items-center justify-center">
                    {/* Carte de connexion */}
                    <div className="w-full max-w-md bg-color4 lg:p-8 p-4 rounded-2xl shadow-lg">
                        <h1 className="text-xl md:text-3xl font-bold font-archivo text-center mb-6">
                            Espace Administrateur 🔐
                        </h1>

                        <form onSubmit={handleLogin} className="flex flex-col gap-4">
                            <div className="flex flex-col gap-2">
                                <label className="text-white text-sm font-medium">
                                    Email <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="admin@thrundrz.fr"
                                    className="w-full px-4 py-3 text-black text-sm rounded-lg border border-gray-300"
                                    required
                                />
                            </div>

                            <div className="flex flex-col gap-2">
                                <label className="text-white text-sm font-medium">
                                    Mot de passe <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="********"
                                    className="w-full px-4 py-3 text-black text-sm rounded-lg border border-gray-300"
                                    required
                                />
                            </div>

                            <button
                                type="submit"
                                disabled={loading}
                                className={`bg-color6 text-white font-bold rounded-xl px-6 py-2 mt-2 w-auto mx-auto ${loading ? "opacity-70 cursor-not-allowed" : "hover:opacity-90"
                                    }`}
                            >
                                {loading ? "Connexion en cours..." : "Se connecter"}
                            </button>
                        </form>
                    </div>
                </div>

                <ToastContainer />
            </main>

            <Footer />
        </>
    );
}